import "./src/styles/global.css"

require("typeface-montserrat")
require("typeface-poppins")
require("typeface-khula")

